/**
 * the commented code is an example for pre-defined method used in button, it's a reference for anyone to write a method
 */

// const consoleLogSomething = ({text, firstNameField}) => {
//   console.log(text);
//   console.log(firstNameField);
//   return {
//     hasOutput: true,
//     outputParams: [
//       {
//         value: 'this is a binded value from method',
//         outputParam: firstNameField
//       }
//     ]
//   }
// }

export default {
  // consoleLogSomething: {
  //   label: 'هذه داله تقوم بطباعه رساله في الكونسول',
  //   call: consoleLogSomething,
  //   params: [
  //     {
  //       name: 'text',
  //       label: 'الجمله التي تريد عرضها'
  //     },
  //     {
  //       name: 'firstNameField',
  //       label: 'اسم الحقل الخاص بالاسم الأول'
  //     },
  //   ]
  // }
};
